"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectPropertiesFactoryFromJS = exports.ProjectPropertiesFactory = void 0;
const immutable_1 = require("immutable");
exports.ProjectPropertiesFactory = (0, immutable_1.Record)({
    id: null,
    name: null,
    status: null,
    fastApprove: null,
    hideApprovals: null,
    delegable: null,
    showParentHistory: null,
    projectVersion: null,
    creationDate: null,
    mobileFormView: null,
    buildAgentId: null,
    sdkVersion: null,
    caption: (0, immutable_1.Map)(),
    description: (0, immutable_1.Map)(),
    useVersion: false,
    createNugetPackage: false,
    autoStartOnStartup: false,
    projectPath: null,
    maxRequestBodySize: null
});
const ProjectPropertiesFactoryFromJS = function (data) {
    return (0, exports.ProjectPropertiesFactory)(Object.assign(Object.assign({}, data), { caption: (0, immutable_1.Map)(data.caption), description: (0, immutable_1.Map)(data.description) }));
};
exports.ProjectPropertiesFactoryFromJS = ProjectPropertiesFactoryFromJS;
//# sourceMappingURL=IProjectProperties.js.map